// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-title_root__C0AHM","levelapp":"banner-title_levelapp__fcA3Z"};